module.exports = __webpack_public_path__ + "static/media/galerija_2019 (40).74e9b9f8.jpg";